module.exports = __webpack_public_path__ + "assets/img/CP-1.e753f7af.jpg";